<template>
  <div>
    <v-btn
      absolute
      dark
      fab
      top
      right
      color="primary"
      style="top:10px;"
      v-if="!isEditStoreList"
      @click="StoreServiceDialog = true"
    >
      <v-icon color="black">add</v-icon>
    </v-btn>
    <StoreServiceForm
      :selected_item="selected_item"
      :dialog="StoreServiceDialog"
      @cancel="cancelDialog()"
      @save="saveDialog()"
      @setDialog="StoreServiceDialog = false"
      :editedIndex="editedIndex"
      :pagination.sync="pagination"
    />
    <v-layout row>
      <!-- <v-flex xs8></v-flex> -->
      <v-flex xs12>
        <v-toolbar dense flat>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search"
            single-line
            hide-details
            style="padding:0;"
          ></v-text-field>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-data-table
      :search="search"
      :headers="headers"
      :items="store_services"
      :loading="store_services.length == 0&& loading_message == 'black'   ? loading_message : false"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ countIndex(props.item) }}</td>
        <td class="text-xs-center">{{ props.item.store_service_name_th }}</td>
        <td class="text-xs-center">{{ props.item.store_service_name_en }}</td>
        <td class="text-xs-center">{{ props.item.store_service_name_cn }}</td>
        <td class="justify-center layout px-0">
          <div v-if="props.index == loading_index">...</div>
          <v-tooltip top>
            <v-btn
              icon
              :disabled="isEditStoreList"
              @click="editService(props.item)"
              v-if="props.index != loading_index"
              slot="activator"
            >
              <v-icon small>edit</v-icon>
            </v-btn>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              icon
              :disabled="isEditStoreList"
              @click="deleteService(props.item)"
              slot="activator"
            >
              <v-icon small>delete</v-icon>
            </v-btn>
            <span>Delete</span>
          </v-tooltip>
        </td>
      </template>
      <template slot="no-data">
        <div v-if="store_services.length == 0 && loading_message != 'black'">No data available</div>
        <div v-else>
          <v-progress-circular :size="30" color="primary" indeterminate></v-progress-circular>
          {{ loading_message == 'black' ? 'Loading data ...' : loading_message}}
        </div>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import StoreServiceForm from "./StoreServiceForm.vue";
import { mapState, mapGetters } from "vuex";
export default {
  data: () => ({
    search: "",
    pagination: { rowsPerPage: 10 },
    loading_message: "black",
    selected_item: {
      store_service_name_th: "",
      store_service_name_en: "",
      store_service_name_cn: ""
    },
    original_data: null,
    StoreServiceDialog: false,
    dialog: false,
    editedIndex: -1,
    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
        value: "name"
      },
      {
        text: "Store Service Name TH",
        align: "center",
        value: "store_service_name_th",
        sortable: false
      },
      {
        text: "Store Service Name EN",
        align: "center",
        value: "store_service_name_en",
        sortable: false
      },
      {
        text: "Store Service Name CN",
        align: "center",
        value: "store_service_name_cn",
        sortable: false
      },
      {
        text: "Actions",
        align: "center",
        value: "name",
        sortable: false
      }
    ]
  }),
  components: {
    StoreServiceForm
  },
  computed: {
    ...mapState({
      store_services: state => state.fetchStoreBack.store_services,
      loading_index: state => state.fetchStoreBack.loading_index
    }),
    ...mapGetters(["isEditStoreList"])
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    countIndex(item) {
      return this.store_services.indexOf(item) + 1;
    },
    deleteService(item) {
      confirm("Are you sure you want to delete this user?") &&
        this.$store.dispatch("fetchStoreBack/delService", item);
    },
    saveDialog() {
      this.StoreServiceDialog = false;
      this.selected_item = {
        store_service_name_th: "",
        store_service_name_en: "",
        store_service_name_cn: ""
      };
    },
    cancelDialog() {
      this.StoreServiceDialog = false;
      if (this.editIndex != -1) {
        this.editedIndex = -1;
        Object.assign(this.selected_item, this.original_data);
      }
      this.selected_item = {
        store_service_name_th: "",
        store_service_name_en: "",
        store_service_name_cn: ""
      };
    },
    async initialize() {
      this.loading_message = await this.$store.dispatch(
        "fetchStoreBack/getDataService"
      );
    },
    editService(item) {
      this.original_data = Object.assign({}, item);
      this.selected_item = item;
      this.StoreServiceDialog = true;
      this.editedIndex = 1;
    }
  }
};
</script>

